import { action } from "typesafe-actions";
import { FeatureFlagsActionTypes, IFeatureFlagsState } from "./types";

export const fetchFlags = () => action(FeatureFlagsActionTypes.FETCH_FLAGS);
export const setFlags = (flags: IFeatureFlagsState | undefined) => action(FeatureFlagsActionTypes.SET_FLAGS, flags);
